// Компоненти іконок для Vibio
import React from 'react';

// Компонент логотипа Vibio (використовує PNG файл)
export const VibioLogo = React.memo(({ className = "", size = "2rem" }) => (
    <img 
        src="/icons/Vibioicon.png" 
        alt="Vibio" 
        className={`vibio-logo ${className}`}
        style={{ 
            height: size, 
            width: 'auto',
            objectFit: 'contain'
        }}
    />
));

// Іконка стрілки (універсальна)
export const ArrowIcon = React.memo(({ className = "", style = {} }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
        style={style}
    >
        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
    </svg>
));

// Іконка плюса (для "Мої лайки")
export const PlusIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
));

// Іконка відео (для "Наступне")
export const PlayNextIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
    </svg>
));

// Іконка виходу
export const ExitIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
    </svg>
));

// Іконка відправки повідомлення
export const SendIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
    </svg>
));

// Іконка завантаження
export const LoadingIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon loading-icon ${className}`}
    >
        <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
    </svg>
));

// Іконка посилання/URL
export const LinkIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
    </svg>
));

// Іконка копіювання
export const CopyIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"/>
    </svg>
));

// Іконка поділитися/спільний доступ  
export const ShareIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12S8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5S19.66 2 18 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12S4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.34C15.11 18.55 15.08 18.77 15.08 19C15.08 20.61 16.39 21.92 18 21.92S20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"/>
    </svg>
));

// Іконка списку/черги
export const QueueIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M320-280q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Zm0-160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0-160q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm120 320h240v-80H440v80Zm0-160h240v-80H440v80Zm0-160h240v-80H440v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/>
    </svg>
));

// Іконка мікрофона
export const MicIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
    </svg>
));

// Іконка вимкненого мікрофона
export const MicOffIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"/>
    </svg>
));

// Іконка галочки (для підтвердження)
export const CheckIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
));

// Іконка хрестика (для скасування)
export const CloseIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
));

// Іконка корони (для хоста)
export const CrownIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M4 18h16v2H4v-2zm1.2-5.4L12 15l6.8-2.4L17 7l-2.5 2L12 6 9.5 9 7 7l-1.8 5.6zM12 8.5l1.5 1.5 1.5-1.5L13.5 6.5h-3L12 8.5z"/>
        <circle cx="7" cy="7" r="1.5"/>
        <circle cx="12" cy="4" r="1.5"/>
        <circle cx="17" cy="7" r="1.5"/>
    </svg>
));

// Іконка відтворення (для поточного відео в черзі)
export const PlayIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M8 5v14l11-7z"/>
    </svg>
));

// Іконка для повідомлення що очікує (годинник)
export const PendingIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z"/>
    </svg>
));

// Іконка видалення (для кнопок видалення)
export const DeleteIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z"/>
    </svg>
));

// Іконка паузи
export const PauseIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
    </svg>
));

// Іконка вимкнення звуку
export const VolumeOffIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
    </svg>
));

// Іконка звуку
export const VolumeUpIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
    </svg>
));

// Іконка повноекранного режиму
export const FullscreenIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
    </svg>
));

// Іконка выхода из полноэкранного режима
export const FullscreenExitIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
    </svg>
));

// Іконка разворачивания по высоте
export const ExpandVerticalIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M13,20H11V4H13M14,9H17.5L12,3.5L6.5,9H10V15H6.5L12,20.5L17.5,15H14V9Z"/>
    </svg>
));

// Іконка чату
export const ChatIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/>
    </svg>
));

// Іконка користувачів
export const UsersIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/>
    </svg>
));

export const UsersIcon2 = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"/>
    </svg>
));

export const UsersIcon3Plus = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"/>
    </svg>
));

// Іконка налаштувань
export const SettingsIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
    </svg>
));

// Іконка відео
export const VideoIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z"/>
    </svg>
));

// Іконка меню (гамбургер)
export const MenuIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"/>
    </svg>
));

// Іконка стрілки назад
export const BackIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"/>
    </svg>
));

// Іконка серця (для "Мої вподобання")
export const HeartIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
));

// Іконка циклічного оновлення (для "Рекомендації")
export const InfinityIcon = React.memo(({ className = "" }) => (
    <svg
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="currentColor"
        className={`icon ${className}`}
    >
        <path d="M12 6V9l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>
    </svg>
));

export const QueueHeaderIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
        <path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z"/>
    </svg>
));

// Іконка замка (для permissions)
export const LockIcon = React.memo(({ className = "" }) => (
    <svg 
        viewBox="0 0 24 24" 
        width="1em" 
        height="1em" 
        fill="currentColor" 
        className={`icon ${className}`}
    >
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
    </svg>
));

export const SentIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3" className={`icon ${className}`}>
        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/>
    </svg>
));

export const DeliveredIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3" className={`icon ${className}`}>
        <path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/>
    </svg>
));

export const ReadIcon = React.memo(({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#8A2BE2" className={`icon ${className}`}>
        <path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"/>
    </svg>
));
